/* SLP Header behavior: mega menu with state search, nav dropdowns, mobile drawer.
   Vanilla JS, attached by data-slp-* attributes:
     [data-slp-header] root, [data-slp-megamenu], [data-slp-megamenu-trigger], [data-slp-megamenu-panel],
     [data-slp-megamenu-search], [data-slp-megamenu-count] (+ data-slp-count-template), [data-slp-state-link],
     [data-slp-dropdown], [data-slp-dropdown-trigger], [data-slp-dropdown-panel],
     [data-slp-drawer-trigger], [data-slp-drawer].
   Each header binds once, guarded by data-slp-init, so loading this file twice is harmless. */
(function () {
  'use strict';

  function initHeader(root) {
    if (!root || root.hasAttribute('data-slp-init')) return;
    root.setAttribute('data-slp-init', '');

    var mega = root.querySelector('[data-slp-megamenu]');
    var megaTrigger = mega && mega.querySelector('[data-slp-megamenu-trigger]');
    var megaPanel = mega && mega.querySelector('[data-slp-megamenu-panel]');
    var search = mega && mega.querySelector('[data-slp-megamenu-search]');
    var count = mega && mega.querySelector('[data-slp-megamenu-count]');
    var countTemplate = (count && count.getAttribute('data-slp-count-template')) || '[visible] / [total]';
    var stateList = mega && mega.querySelector('.slp-header__states');
    var stateLinks = mega ? Array.prototype.slice.call(mega.querySelectorAll('[data-slp-state-link]')) : [];

    var dropdowns = Array.prototype.slice.call(root.querySelectorAll('[data-slp-dropdown]')).map(function (group) {
      return {
        group: group,
        trigger: group.querySelector('[data-slp-dropdown-trigger]'),
        panel: group.querySelector('[data-slp-dropdown-panel]')
      };
    }).filter(function (d) { return d.trigger && d.panel; });

    var drawerTrigger = root.querySelector('[data-slp-drawer-trigger]');
    var drawer = root.querySelector('[data-slp-drawer]');

    function closeMega() {
      if (!megaPanel) return;
      megaPanel.hidden = true;
      megaTrigger.setAttribute('aria-expanded', 'false');
    }

    function closeDropdowns() {
      dropdowns.forEach(function (d) {
        d.panel.hidden = true;
        d.trigger.setAttribute('aria-expanded', 'false');
      });
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.hidden = true;
      drawerTrigger.setAttribute('aria-expanded', 'false');
    }

    if (megaTrigger && megaPanel) {
      megaTrigger.addEventListener('click', function (event) {
        event.preventDefault();
        var willOpen = megaPanel.hidden;
        closeDropdowns();
        if (willOpen) {
          megaPanel.hidden = false;
          megaTrigger.setAttribute('aria-expanded', 'true');
          if (search) search.focus();
        } else {
          closeMega();
        }
      });
    }

    if (search) {
      search.addEventListener('input', function () {
        var term = search.value.trim().toLowerCase();
        var visible = 0;
        stateLinks.forEach(function (link) {
          var matches = link.textContent.toLowerCase().indexOf(term) !== -1;
          link.parentElement.hidden = !matches;
          if (matches) visible += 1;
        });
        if (stateList) stateList.classList.toggle('slp-header__states--filtered', term !== '');
        if (count) count.textContent = countTemplate.replace('[visible]', visible).replace('[total]', stateLinks.length);
      });

      search.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        var first = stateLinks.filter(function (link) { return !link.parentElement.hidden; })[0];
        if (first) {
          event.preventDefault();
          window.location.href = first.href;
        }
      });
    }

    dropdowns.forEach(function (d) {
      d.trigger.addEventListener('click', function (event) {
        event.preventDefault();
        var wasOpen = !d.panel.hidden;
        closeDropdowns();
        closeMega();
        if (!wasOpen) {
          d.panel.hidden = false;
          d.trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    if (drawerTrigger && drawer) {
      drawerTrigger.addEventListener('click', function () {
        var willOpen = drawer.hidden;
        drawer.hidden = !willOpen;
        drawerTrigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    }

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Node)) return;
      if (mega && !mega.contains(event.target)) closeMega();
      dropdowns.forEach(function (d) {
        if (!d.group.contains(event.target)) {
          d.panel.hidden = true;
          d.trigger.setAttribute('aria-expanded', 'false');
        }
      });
      if (drawer && !drawer.hidden && !root.contains(event.target)) closeDrawer();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var megaWasOpen = megaPanel && !megaPanel.hidden;
      closeMega();
      closeDropdowns();
      if (megaWasOpen) megaTrigger.focus();
      if (drawer && !drawer.hidden) {
        closeDrawer();
        drawerTrigger.focus();
      }
    });

    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 60.0625rem)').matches) closeDrawer();
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-slp-header]'), initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
